export const SET_SHARE_ITEMS_RES_STATUS: string = 'SET_SHARE_ITEMS_RES_STATUS';
export const SET_DOC_APPROVAL_STATUS: string = 'SET_DOC_APPROVAL_STATUS';
